import { ConfigurationSecurity } from "@/model/data/security/ConfigurationSecurity";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class RevertInstallationSecurityConfigurationResData extends ApiGenericResponse {
    referenceConfiguration: ConfigurationSecurity;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.ReferenceConfiguration) {
            this.referenceConfiguration = new ConfigurationSecurity();
            this.referenceConfiguration.parse(obj.ReferenceConfiguration);
        }
    }
}
